export default __webpack_public_path__ + "static/media/audio-icon.0d1ade86.svg";